import utils from 'utils';
import {useEffect, useState} from 'react';
import moment from 'moment';

import {SidePanelListItem} from '@components/export';

export const SidePanelList = (props: {
    itemList: apiOrder[] | apiProduct[],
    loading: boolean,
    mode: 'product' | 'order',
    currentIndex: number | null,
    showAll: boolean,
    flags: {[name: string]: boolean},

    onItemClick: (index: number) => void,
}) => {
    const [showIndex, setShowIndex] = useState([]);

    const handle = {
        splitItemListByDate() {
            return props.itemList.reduce((groups, order, index) => {
                let dateObj = moment((order as apiOrder).dateCreated);

                if (dateObj.day() === 6) {
                    dateObj = dateObj.add(2, 'day');
                }

                if (dateObj.day() === 0) {
                    dateObj = dateObj.add(1, 'day');
                }

                const date = dateObj.format('YYYY-MM-DD');

                if (!groups[date]) {
                    groups[date] = {
                        orders: {},
                        qtyDone: 0,
                        qtyToDo: 0,
                        isCurrent: false,
                    };
                }

                groups[date].orders[index] = order;
                groups[date].qtyDone += order.qtyDone;
                groups[date].qtyToDo += order.qtyToDo;
                groups[date].isCurrent = groups[date].isCurrent || index === props.currentIndex;

                return groups;
            }, {});
        },
        getGroupColor(group) {
            const colors = {
                new: '#BEC3C7',
                in_progress: '#F1C40F',
                ready: '#3ACC75',
            };

            return !group.qtyDone ? colors.new : group.qtyDone === group.qtyToDo ? colors.ready : colors.in_progress;
        },
        getListItemJSX(order, index) {
            return <div
                className={
                    classMap.listItem +
                    (+index === props.currentIndex ? ' ' + classMap.listItemActive : '')
                }
                key={+index}
            >
                <SidePanelListItem
                    item={order}
                    mode={props.mode}
                    loading={+index === props.currentIndex && props.loading}
                    active={+index === props.currentIndex}

                    onClick={() => props.onItemClick(+index)}
                />
            </div>;
        },
        setCurrentGroupIndex() {
            const currentIndex = Object.entries(handle.splitItemListByDate())
                .findIndex((groupEntry: [string, any]) => groupEntry[1].isCurrent);

            if (currentIndex > -1) {
                setShowIndex([currentIndex]);
            } else {
                setShowIndex([]);
            }
        },
    };

    useEffect(() => {
        handle.setCurrentGroupIndex();
    }, [props.flags]);

    return <div className={cmpClass}>
        <div className={classMap.wrapper}>
            {
                props.mode === 'order' && props.flags.showPrevious ?
                    Object.entries(handle.splitItemListByDate()).map((groupEntry: [string, any], groupI) => {
                        const [date, group] = groupEntry;
                        const dateMoment = moment(date + ' 00:00');

                        return <div
                            className={classMap.group}
                            key={groupI}
                        >
                            <div
                                className={classMap.groupHeaderWrapper}
                                style={{
                                    borderColor: handle.getGroupColor(group),
                                }}
                                onClick={() => {
                                    setShowIndex(
                                        showIndex.includes(groupI) ?
                                            [...showIndex.filter((item) => item !== groupI)] :
                                            [...showIndex, groupI],
                                    );
                                }}
                            >
                                <div
                                    style={{backgroundColor: handle.getGroupColor(group)}}
                                    className={
                                        classMap.groupHeader +
                                        (showIndex.includes(groupI) ? ' ' + classMap.groupHeaderActive : '')
                                    }
                                >
                                    <span>
                                        {
                                            dateMoment.format('DD.MM.YYYY') +
                                            ' - ' +
                                            dateMoment.format('dddd').substring(0, 2) +
                                            ''
                                        }
                                    </span>
                                    <div>
                                        <span>
                                            {
                                                props.loading && group.isCurrent ?
                                                    '- / -' :
                                                    group.qtyDone + ' / ' + group.qtyToDo
                                            }
                                        </span>
                                        {
                                            props.showAll ?
                                                <></> :
                                                showIndex.includes(groupI) ?
                                                    <i className={'iconfa-arrowUp'}></i> :
                                                    <i className={'iconfa-arrowDown'}></i>
                                        }
                                    </div>
                                </div>
                            </div>
                            <div
                                className={
                                    classMap.groupList +
                                    (showIndex.includes(groupI) || props.showAll ? ' ' + classMap.groupListActive : '')
                                }
                            >
                                {
                                    Object.entries(group.orders).map((orderEntry) => {
                                        const [orderIndex, order] = orderEntry;

                                        return handle.getListItemJSX(order, orderIndex);
                                    })
                                }
                            </div>
                        </div>;
                    }) : props.itemList.map((order, i) => {
                        return handle.getListItemJSX(order, i);
                    })
            }
        </div>
    </div>;
};

const cmpClass = 'side-panel-list';

const classMap = utils.generateClassMap(cmpClass, {
    listItem: 'list-item',
    listItemActive: 'list-item--active',
    listItemLoading: 'list-item--loading',
    wrapper: 'wrapper',
    group: 'group',
    groupHeaderWrapper: 'group-header-wrapper',
    groupHeader: 'group-header',
    groupHeaderActive: 'group-header--active',
    groupList: 'group-list',
    groupListActive: 'group-list--active',
});
